import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { NotificationCollection } from './notification.types';

export const useNotification = () => {
  const notificationCollection: NotificationCollection = useRxCollection(
    RxdbCollectionName.NOTIFICATION,
  );

  const [notificationInitialized, setnotificationInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (notificationCollection) setnotificationInitialized(true);
  }, [notificationCollection]);

  const setNotificationAsRead = async (pkUSerAlertId: string[]) => {
    try {
      if (notificationCollection) {
        const result = await notificationCollection
          .find({
            selector: { pkUSerAlertId: { $in: pkUSerAlertId } },
          })
          .update({
            $set: {
              isRead: true,
            },
          });
        return result;
      }
    } catch (error) {
      sentryCaptureException(
        error,
        '~ file: useNotification.tsx ~ line 57 ~ setNotificationAsRead ~',
      );
    }
  };

  const setNotificationAsDisabled = async (pkUSerAlertId: string[]) => {
    try {
      if (notificationCollection) {
        const result = await notificationCollection
          .find({
            selector: { pkUSerAlertId: { $in: pkUSerAlertId } },
          })
          .update({
            $set: {
              isActive: false,
            },
          });
        return result;
      }
    } catch (error) {
      sentryCaptureException(
        error,
        '~ file: useNotification.tsx ~ line 57 ~ setNotificationAsDisabled ~',
      );
    }
  };

  return {
    notificationInitialized,
    notificationCollection,
    setNotificationAsRead,
    setNotificationAsDisabled,
  };
};
